import PackingListDetails from "./PackingListDetails";

export default PackingListDetails;
